import React, { useContext, useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import {
  ControlledMenu as RControlledMenu,
  MenuItem as RMenuItem,
  SubMenu as RSubMenu,
} from "@szhsin/react-menu";
import GeneralContext from "../GeneralContext/GeneralContext";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import PageBody from "../GeneralComponents/PageBody";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import GenericTextTable from "./GenericTextTable";
import OPReport from "./OPReport";
import ReportSup from "./ReportSup";
import ReportePromedioMensual from "./ReportePromedioMensual";

const MENU_CSS = `
.sagec-menu{--accent:#003B8D;--bg:#fff;--fg:#1f2733;--hover:rgba(0,59,141,0.08);--selected:rgba(0,59,141,0.14);background:var(--bg);color:var(--fg);border:1px solid rgba(0,0,0,0.12);border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.08);padding:8px 0;min-width:320px}
.sagec-menu .szh-menu__item{padding:10px 14px;line-height:1.2;white-space:normal;color:var(--fg);border-radius:6px;margin:0 6px}
.sagec-menu .szh-menu__item--hover{background:var(--hover)}
.sagec-menu .szh-menu__item--active{background:var(--selected)}
.sagec-menu.sagec-submenu{margin-left:-6px;min-width:320px}
`;

const BUTTONS = [
  {
    label: "Reporte de supervisión",
    path: "reporte-de-supervision",
    size: 4,
    children: [
      {
        label: "Monitoreo en Línea",
        path: "reporte-de-supervision/monitoreo",
        to: "supervision/monitoreo",
        api: "/api/supervision/monitoreo",
        columns: [],
        filters: [],
      },
      {
        label: "Análisis tráfico y comportamiento",
        path: "reporte-de-supervision/analisis",
        to: "supervision/analisis",
        children: [
          {
            label: "Máximos diarios",
            path: "supervision/analisis/maximos-diarios",
            to: "supervision/analisis/maximos-diarios",
            api: "",
            columns: [],
            filters: [],
          },
          {
            label: "Disponibilidad mensual",
            path: "supervision/analisis/disponibilidad-mensual",
            to: "supervision/analisis/disponibilidad-mensual",
            api: "",
            columns: [],
            filters: [],
          },
          {
            label: "Promedio de tráfico mensual",
            path: "supervision/analisis/promedio-trafico",
            to: "supervision/analisis/promedio-trafico",
            api: "",
            columns: [],
            filters: [],
          },
    ],
  },]},
  {
    label: "Comercial de Servicio de conectividad",
    path: "comercial",
    size: 4,
    children: [
      {
        label: "PREFACTURA",
        path: "comercial/prefactura",
        to: "comercial/prefactura",
        api: "vw_prefactura",
        periodoMode: "local",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "total_rbd", label: "Cantidad RBD", align: "right", minWidth: 140, sortable: true, sortType: "number" },
          { id: "recibido_en", label: "Fecha recepción", align: "right", minWidth: 160, sortable: true, sortType: "date" },
          { id: "is_recibido", label: "Recibido", align: "right", minWidth: 120, sortable: true, sortType: "string" },
          { id: "url_operador", label: "URL", align: "center", minWidth: 160, sortable: false, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 4 },
          { item: "nombre_operador", name: "Operador", size: 4 },
          { item: "is_recibido", name: "Recibido", size: 4 },
        ],
      },
      {
        label: "Descuentos por zonas",
        path: "comercial/descuentos-por-zona",
        to: "comercial/nueva",
        api: "/api/comercial/descuentos-por-zona",
        columns: [
          { id: "campo", label: "Campo" },
          { id: "valor", label: "Valor" },
        ],
      },
    ],
  },
  {
    label: "Reporte de Operación",
    path: "reporte-de-operacion",
    size: 4,
    children: [
      {
        label: "Altas/Bajas/Traslado",
        path: "operacion/altas-bajas-traslado",
        to: "operacion/altas-bajas-traslado",
        api: "vw_altas_bajas",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "rbd", label: "RBD", minWidth: 100, sortable: true, sortType: "number" },
          { id: "zona_id", label: "Zona", minWidth: 100, sortable: true, sortType: "number" },
          { id: "descripcion_evento", label: "Tipo", minWidth: 120, sortable: true, sortType: "string" },
          { id: "fecha_evento", label: "Fecha", minWidth: 120, sortable: true, sortType: "date" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "descripcion_evento", name: "Tipo", size: 3 },
        ],
      },
      {
        label: "Cambios de configuración",
        path: "operacion/cambios-config",
        to: "operacion/cambios-config",
        api: "vw_cambio_configuracion",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "rbd", label: "RBD", minWidth: 100, sortable: true, sortType: "number" },
          { id: "zona_id", label: "Zona", minWidth: 100, sortable: true, sortType: "number" },
          { id: "descripcion_evento", label: "Descripción", minWidth: 120, sortable: true, sortType: "string" },
          { id: "fecha_evento", label: "Fecha", minWidth: 120, sortable: true, sortType: "date" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "rbd", name: "RBD", size: 3 },
        ],
      },
      {
        label: "Estadística sobre uso de la mesa de ayuda",
        path: "operacion/estadistica-mesa-ayuda",
        to: "operacion/estadistica-mesa-ayuda",
        api: "vw_mesa_ayuda",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 90, sortable: true, sortType: "number" },
          { id: "rbd", label: "RBD", minWidth: 110, sortable: true, sortType: "number" },
          { id: "tipo_evento", label: "Tipo evento", minWidth: 110, sortable: true, sortType: "string" },
          { id: "cantidad_tickets", label: "Tickets", align: "right", minWidth: 110, sortable: true, sortType: "number" },
          { id: "cantidad_reincidentes", label: "Reincidentes", align: "right", minWidth: 110, sortable: true, sortType: "number" },
          { id: "tiempo_resolucion", label: "Tiempo resolución (s)", align: "right", minWidth: 110, sortable: true, sortType: "number" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "rbd", name: "RBD", size: 3 },
          { item: "tipo_evento", name: "Tipo evento", size: 3 },
        ],
      },
      {
        label: "Tickets de operadoras o mesa de ayuda",
        path: "operacion/tickets",
        to: "operacion/tickets",
        api: "vw_tickets_mesa_ayuda",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 90, sortable: true, sortType: "number" },
          { id: "rbd", label: "RBD", minWidth: 110, sortable: true, sortType: "number" },
          { id: "ticket_id", label: "Ticket", minWidth: 120, sortable: true, sortType: "number" },
          { id: "tipo_evento", label: "Tipo evento", minWidth: 120, sortable: true, sortType: "string" },
          { id: "fecha_hora_ocurrencia", label: "Ocurrencia", minWidth: 170, sortable: true, sortType: "date" },
          { id: "fecha_hora_mesa_ayuda", label: "Mesa de ayuda", minWidth: 170, sortable: true, sortType: "date" },
          { id: "fecha_hora_recursos", label: "Recursos", minWidth: 170, sortable: true, sortType: "date" },
          { id: "fecha_hora_solucionado", label: "Solucionado", minWidth: 170, sortable: true, sortType: "date" },
          { id: "severidad", label: "Severidad", align: "right", minWidth: 110, sortable: true, sortType: "number" },
          { id: "interna_o_externa", label: "Int/Ext", align: "right", minWidth: 100, sortable: true, sortType: "string" },
          { id: "extension_de_la_falla", label: "Ext. falla", align: "right", minWidth: 120, sortable: true, sortType: "number" },
          { id: "descripcion_de_la_falla", label: "Descripción falla", minWidth: 240, sortable: true, sortType: "string" },
          { id: "texto_operador", label: "Texto operador", minWidth: 260, sortable: true, sortType: "string" },
          { id: "texto_ees", label: "Texto EES", minWidth: 320, maxWidth: 320, sortable: true, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "rbd", name: "RBD", size: 3 },
          { item: "tipo_evento", name: "Tipo evento", size: 3 },
          { item: "severidad", name: "Severidad", size: 3 },
          { item: "interna_o_externa", name: "Interna/Externa", size: 3 },
          { item: "extension_de_la_falla", name: "Extensión falla", size: 3 },
        ],
      },
      {
        label: "Labores de mantenimiento",
        path: "operacion/labores-mantenimiento",
        to: "operacion/labores-mantenimiento",
        api: "vw_mantenimiento",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 80, sortable: true, sortType: "number" },
          { id: "rbd", label: "RBD", minWidth: 100, sortable: true, sortType: "number" },
          { id: "fecha_mantenimiento", label: "Fecha mantenimiento", minWidth: 150, sortable: true, sortType: "date" },
          { id: "descripcion", label: "Descripción", minWidth: 250, maxWidth: 250, sortable: true, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "rbd", name: "RBD", size: 3 },
        ],
      },
    ],
  },
  {
    label: "Reporte de Uso",
    path: "reporte-de-uso",
    size: 3,
    children: [
      {
        label: "Visitas mensuales por zona",
        path: "uso/visitas-mensuales-por-zona",
        to: "uso/visitas-mensuales-por-zona",
        api: "vw_visitas_zona",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 100, sortable: true, sortType: "number" },
          { id: "categoria", label: "Categoría", minWidth: 120, sortable: true, sortType: "string" },
          { id: "subcategoria", label: "Subcategoría", minWidth: 120, sortable: true, sortType: "string" },
          { id: "descripcion", label: "Descripción", minWidth: 120, sortable: true, sortType: "string" },
          { id: "visitas", label: "N° visitas", minWidth: 120, sortable: true, sortType: "number" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "categoria", name: "Categoría", size: 3 },
          { item: "subcategoria", name: "Subcategoría", size: 3 },
        ],
      },
      {
        label: "Top 10 dominios por zona (mes calendario)",
        path: "uso/top-10-dominios-por-zona-mes-calendario",
        to: "uso/top-10-dominios-por-zona-mes-calendario",
        api: "vw_visitas_top10",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 100, sortable: true, sortType: "number" },
          { id: "lugar_ranking", label: "Ranking", minWidth: 120, sortable: true, sortType: "number" },
          { id: "dominio", label: "Dominio", minWidth: 120, sortable: true, sortType: "string" },
          { id: "visitas", label: "N° visitas", minWidth: 120, sortable: true, sortType: "number" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "lugar_ranking", name: "Ranking", size: 3 },
        ],
      },
      {
        label: "Visitas mensuales por zonas (dominios interés ministerial)",
        path: "uso/visitas-mensuales-dominios-interes-ministerial",
        to: "uso/visitas-mensuales-dominios-interes-ministerial",
        api: "vw_visitas_interes_mineduc",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 100, sortable: true, sortType: "number" },
          { id: "visitas", label: "N° visitas", minWidth: 120, sortable: true, sortType: "number" },
          { id: "dominio", label: "Dominio", minWidth: 120, sortable: true, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 4 },
          { item: "nombre_operador", name: "Operador", size: 4 },
          { item: "zona_id", name: "ZONA", size: 4 },
        ],
      },
      {
        label: "Intentos violación control parental",
        path: "uso/intentos-violacion-control-parental",
        to: "uso/intentos-violacion-control-parental",
        api: "vw_control_parental",
        columns: [
          { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
          { id: "rbd", label: "RBD", minWidth: 120, sortable: true, sortType: "number" },
          { id: "zona_id", label: "Zona", minWidth: 100, sortable: true, sortType: "number" },
          { id: "visitas", label: "N° visitas", minWidth: 120, sortable: true, sortType: "number" },
          { id: "dominio", label: "Dominio", minWidth: 260, sortable: true, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "rbd", name: "RBD", size: 3 },
        ],
      },
      {
        label: "Eventos de seguridad de la información en el período",
        path: "uso/eventos-seguridad-informacion",
        to: "uso/eventos-seguridad-informacion",
        api: "vw_seguridad",
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
          { id: "zona_id", label: "Zona", minWidth: 90, sortable: true, sortType: "number" },
          { id: "evento_id", label: "Evento", minWidth: 110, sortable: true, sortType: "number" },
          { id: "descripcion_incidente", label: "Incidente", minWidth: 200, sortable: true, sortType: "string" },
          { id: "fecha_hora_inicio_evento", label: "Inicio", minWidth: 170, sortable: true, sortType: "date" },
          { id: "fecha_hora_termino_evento", label: "Término", minWidth: 170, sortable: true, sortType: "date" },
          { id: "rbds", label: "RBD(s)", minWidth: 320, maxWidth: 320, sortable: true, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
          { item: "zona_id", name: "ZONA", size: 3 },
          { item: "evento_id", name: "Evento", size: 3 },
          { item: "descripcion_incidente", name: "Incidente", size: 3 },
        ],
      },
      {
        label: "Uso del servicio para muestra de ees",
        path: "uso/ees",
        children: [
          {
            label: "Categorías de páginas con cantidad de visitas",
            path: "uso/ees/categorias-visitas",
            to: "uso/ees/categorias-visitas",
            api: "vw_visitas_por_categoria",
            columns: [
              { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
              { id: "nombre_operador", label: "Operador", minWidth: 180, sortable: true, sortType: "string" },
              { id: "zona_id", label: "Zona", minWidth: 90, sortable: true, sortType: "number" },
              { id: "rbd", label: "RBD", minWidth: 100, sortable: true, sortType: "number" },
              { id: "fecha_hora_del_mes", label: "Fecha / Hora", minWidth: 120, sortable: true, sortType: "date" },
              { id: "categoria", label: "Categoría", minWidth: 180, sortable: true, sortType: "string" },
              { id: "subcategoria", label: "Subcategoría", minWidth: 180, sortable: true, sortType: "string" },
              { id: "visitas", label: "Visitas", align: "right", minWidth: 140, sortable: true, sortType: "number" },
            ],
            filters: [
              { item: "periodo", name: "Periodo", size: 3 },
              {
                id: "nombre_operador",
                item: "operador",
                name: "Operador",
                size: 3,
                source: "operadores",
                queryParam: "id_operador",
                defaultValue: "LUZLINARES S.A.",
              },
              { item: "zona_id", name: "Zona", size: 3 },
              { item: "rbd", name: "RBD", size: 3 },
              { item: "categoria", name: "Categoría", size: 3 },
              { item: "subcategoria", name: "Subcategoría", size: 3 },
            ],
          },
          {
            label: "Dominios visitados cada día top 10",
            path: "uso/ees/top-10-diario",
            to: "uso/ees/top-10-diario",
            api: "vw_dominios_visitados",
            columns: [
              { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
              { id: "dia_del_mes", label: "Día", minWidth: 120, sortable: true, sortType: "number" },
              { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
              { id: "zona_id", label: "Zona", minWidth: 80, align: "right", sortable: true, sortType: "number" },
              { id: "rbd", label: "RBD", minWidth: 80, sortable: true, sortType: "number" },
              { id: "posicion_en_ranking", label: "Ranking", minWidth: 80, align: "right", sortable: true, sortType: "number" },
              { id: "visitas", label: "Visitas", minWidth: 120, align: "right", sortable: true, sortType: "number" },
              { id: "dominio", label: "Dominio / IP", minWidth: 320, sortable: true, sortType: "string" },
            ],
            filters: [
              { item: "periodo", name: "Periodo", size: 3 },
              {
                id: "nombre_operador",
                item: "operador",
                name: "Operador",
                size: 3,
                source: "operadores",
                queryParam: "id_operador",
                defaultValue: "LUZLINARES S.A.",
              },
              { item: "zona_id", name: "ZONA", size: 3 },
              { item: "rbd", name: "RBD", size: 3 },
              { item: "dia_del_mes", name: "Día", size: 3 },
              { item: "posicion_en_ranking", name: "Ranking", size: 3 },
            ],
          },
          {
            label: "Cantidad de visitas por hora del mes en un ees",
            path: "uso/ees/visitas-por-hora",
            to: "uso/ees/visitas-por-hora",
            api: "vw_dominios_interes_visitados",
            columns: [
              { id: "periodo", label: "Periodo", minWidth: 100, sortable: true, sortType: "date" },
              { id: "nombre_operador", label: "Operador", minWidth: 200, sortable: true, sortType: "string" },
              { id: "zona_id", label: "Zona", minWidth: 80, align: "right", sortable: true, sortType: "number" },
              { id: "rbd", label: "RBD", minWidth: 100, sortable: true, sortType: "number" },
              { id: "fecha_hora_del_mes", label: "Fecha / Hora", minWidth: 120, sortable: true, sortType: "date" },
              { id: "visitas", label: "Visitas", minWidth: 80, align: "right", sortable: true, sortType: "number" },
              { id: "dominio", label: "Dominio / IP", minWidth: 250, sortable: true, sortType: "string" },
            ],
            filters: [
              { item: "periodo", name: "Periodo", size: 3 },
              {
                id: "nombre_operador",
                item: "operador",
                name: "Operador",
                size: 3,
                source: "operadores",
                queryParam: "id_operador",
                defaultValue: "LUZLINARES S.A.",
              },
              { item: "zona_id", name: "ZONA", size: 3 },
              { item: "rbd", name: "RBD", size: 3 },
              { item: "dominio", name: "Dominio / IP", size: 3 },
            ],
          },
        ],
      },
    ],
  },
  {
    label: "Listado de páginas maliciosas",
    path: "listado-de-paginas-maliciosas",
    to: "paginas-maliciosas",
    size: 3,
    api: "vw_maliciosas",
    columns: [
      { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
      { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
      { id: "categoria", label: "Categoría", minWidth: 160, sortable: true, sortType: "string" },
      { id: "subcategoria", label: "Subcategoría", minWidth: 160, sortable: true, sortType: "string" },
      { id: "tipo_de_categoria", label: "Tipo", align: "right", minWidth: 90, sortable: true, sortType: "string" },
      { id: "descripcion", label: "Descripción", minWidth: 320, sortable: true, sortType: "string" },
    ],
    filters: [
      { item: "periodo", name: "Periodo", size: 3 },
      {
        id: "nombre_operador",
        item: "operador",
        name: "Operador",
        size: 3,
        source: "operadores",
        queryParam: "id_operador",
        defaultValue: "LUZLINARES S.A.",
      },
      { item: "categoria", name: "Categoría", size: 3 },
      { item: "subcategoria", name: "Subcategoría", size: 3 },
      { item: "tipo_de_categoria", name: "Tipo", size: 3 },
    ],
  },
  {
    label: "Acuerdos privados",
    path: "acuerdos-privados",
    to: "acuerdos",
    size: 3,
    api: "vw_acuerdosprivados",
    columns: [
      { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
      { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
      { id: "zona_id", label: "Zona", minWidth: 90, sortable: true, sortType: "number" },
      { id: "rbd", label: "RBD", minWidth: 120, sortable: true, sortType: "number" },

      { id: "tipo_acuerdo", label: "Tipo acuerdo", minWidth: 140, sortable: true, sortType: "number" },
      { id: "recibido_en", label: "Fecha recepción", minWidth: 170, sortable: true, sortType: "date" },

      { id: "fecha_acuerdo", label: "Fecha acuerdo", minWidth: 140, sortable: true, sortType: "date" },
      { id: "fecha_implementacion", label: "Fecha implementación", minWidth: 170, sortable: true, sortType: "date" },

      { id: "incremento_ancho_de_banda_bajada", label: "Inc. bajada (Mbps)", align: "right", minWidth: 160, sortable: true, sortType: "number" },
      { id: "incremento_ancho_de_banda_subida", label: "Inc. subida (Mbps)", align: "right", minWidth: 160, sortable: true, sortType: "number" },

      { id: "precio_megabit_por_segundo_con_iva_bajada", label: "$/Mbps bajada (IVA)", align: "right", minWidth: 170, sortable: true, sortType: "number" },
      { id: "precio_megabit_por_segundo_con_iva_subida", label: "$/Mbps subida (IVA)", align: "right", minWidth: 170, sortable: true, sortType: "number" },

      { id: "incremento_ancho_de_banda_bajada_internacional", label: "Inc. bajada int. (Mbps)", align: "right", minWidth: 190, sortable: true, sortType: "number" },
      { id: "precio_megabit_por_segundo_con_iva_bajada_internacional", label: "$/Mbps bajada int. (IVA)", align: "right", minWidth: 210, sortable: true, sortType: "number" },

      { id: "descripcion_del_acuerdo", label: "Descripción", minWidth: 320, maxWidth: 320, sortable: true, sortType: "string" },
    ],
    filters: [
      { item: "periodo", name: "Periodo", size: 3 },
      { item: "nombre_operador", name: "Operador", size: 3 },
      { item: "zona_id", name: "Zona", size: 3 },
      { item: "tipo_acuerdo", name: "Tipo acuerdo", size: 3 },
      { item: "rbd", name: "RBD", size: 3 },
    ]
  },
  {
    label: "Otros reportes",
    path: "otros-reportes",
    to: "otros",
    size: 3,
    periodoMode: "local",
    api: "otros_reportes",
    
        columns: [
          { id: "periodo", label: "Periodo", minWidth: 120, sortable: true, sortType: "date" },
          { id: "nombre_archivo", label: "Nombre", minWidth: 220, sortable: true, sortType: "string" },

          { id: "nombre_operador", label: "Operador", minWidth: 220, sortable: true, sortType: "string" },
          { id: "recibido_en", label: "Fecha recepción", align: "right", minWidth: 160, sortable: true, sortType: "date" },
          { id: "url", label: "Descarga", align: "center", minWidth: 160, sortable: false, sortType: "string" },
        ],
        filters: [
          { item: "periodo", name: "Periodo", size: 3 },
          { item: "nombre_operador", name: "Operador", size: 3 },
        ],
  },
];


const BASE = "/reportes";
function normalizeTo(to) {
  return to?.startsWith("/") ? `${BASE}${to}` : `${BASE}/${to}`;
}
function stripBase(pathname) {
  return pathname.startsWith(`${BASE}/`) ? pathname.slice(BASE.length + 1) : "";
}
function findPath(nodes, predicate, trail = []) {
  for (const n of nodes) {
    const nextTrail = [...trail, n];
    if (predicate(n)) return nextTrail;
    if (n.children) {
      const res = findPath(n.children, predicate, nextTrail);
      if (res) return res;
    }
  }
  return null;
}
const LEAVES = (() => {
  const acc = [];
  (function walk(nodes) {
    nodes.forEach((n) => {
      if (n.children?.length) walk(n.children);
      else if (n.to) acc.push(n);
    });
  })(BUTTONS);
  return acc;
})();
function findLeafByPathname(pathname) {
  const relative = stripBase(pathname);
  return LEAVES.find((l) => l.to === relative);
}

function NodeSubMenu({ node, onNavigate }) {
  const hasChildren = !!(node.children && node.children.length);
  if (!hasChildren) {
    return (
      <RMenuItem
        onClick={() => {
          if (!node.to) return;
          onNavigate(normalizeTo(node.to));
        }}
      >
        {node.label}
      </RMenuItem>
    );
  }
  return (
    <RSubMenu
      label={node.label}
      direction="right"
      align="start"
      offsetX={0}
      offsetY={0}
      transition
      submenuOpenDelay={110}
      submenuCloseDelay={220}
      portal={false}
      viewScroll="auto"
      menuClassName="sagec-menu sagec-submenu"
    >
      {node.children.map((child) => (
        <NodeSubMenu key={child.path} node={child} onNavigate={onNavigate} />
      ))}
    </RSubMenu>
  );
}

function HoverMenuButton({ node }) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentRel = stripBase(location.pathname);
  const hasChildren = !!(node.children && node.children.length);
  const anyChildSelected =
    hasChildren && node.children.some((c) => (c.to ? currentRel.startsWith(c.to) : false));

  const [isOpen, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const anchorRef = useRef(null);
  const closeTimer = useRef(null);

  const ACTIVE_BG = "#003B8D";
  const ACTIVE_BORDER = "#003B8D";
  const ACTIVE_COLOR = "#FFFFFF";
  const DEFAULT_BG = "#FFFFFF";
  const DEFAULT_BORDER = "#003B8D";
  const DEFAULT_COLOR = "#003B8D";
  const DEFAULT_FS = "0.8rem";

  const openMenu = () => {
    clearTimeout(closeTimer.current);
    setOpen(true);
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpen(false), 160);
  };

  if (!hasChildren) {
    const isActive = hover || (node.to && currentRel.startsWith(node.to));
    return (
      <span
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{ display: "block", width: "100%" }}
      >
        <PageButtonWhite
          width="100%"
          fs={DEFAULT_FS}
          onClick={() => {
            if (!node.to) return;
            navigate(normalizeTo(node.to), { state: { resetTs: Date.now() } });
          }}
          bgColor={isActive ? ACTIVE_BG : DEFAULT_BG}
          border={isActive ? ACTIVE_BORDER : DEFAULT_BORDER}
          color={isActive ? ACTIVE_COLOR : DEFAULT_COLOR}
        >
          {node.label}
        </PageButtonWhite>
      </span>
    );
  }

  const isActive = isOpen || anyChildSelected;

  return (
    <>
      <style>{MENU_CSS}</style>
      <span
        ref={anchorRef}
        onMouseEnter={openMenu}
        onMouseLeave={scheduleClose}
        style={{ display: "block", width: "100%" }}
      >
        <PageButtonWhite
          width="100%"
          fs={DEFAULT_FS}
          bgColor={isActive ? ACTIVE_BG : DEFAULT_BG}
          border={isActive ? ACTIVE_BORDER : DEFAULT_BORDER}
          color={isActive ? ACTIVE_COLOR : DEFAULT_COLOR}
        >
          {node.label}
        </PageButtonWhite>
      </span>

      <RControlledMenu
        state={isOpen ? "open" : "closed"}
        anchorRef={anchorRef}
        onClose={() => setOpen(false)}
        direction="bottom"
        align="start"
        offsetX={0}
        offsetY={6}
        transition
        portal={false}
        viewScroll="auto"
        onMouseEnter={() => clearTimeout(closeTimer.current)}
        onMouseLeave={scheduleClose}
        menuClassName="sagec-menu"
      >
        {node.children.map((child) => (
          <NodeSubMenu
            key={child.path}
            node={child}
            onNavigate={(to) => navigate(to, { state: { resetTs: Date.now() } })}
          />
        ))}
      </RControlledMenu>
    </>
  );
}

function RouteDrivenSubView() {
  const location = useLocation();
  const navigate = useNavigate();
  const leaf = findLeafByPathname(location.pathname);

  useEffect(() => {
    const rel = stripBase(location.pathname);
    if (rel && !leaf) navigate("/404", { replace: true });
  }, [location.pathname, leaf, navigate]);

  if (leaf && leaf.to === "supervision/monitoreo") {
    return <OPReport />;
  }

  if (leaf && leaf.to === "supervision/analisis/maximos-diarios") {
  return (
    <ReportSup
      baseUrl="/service/grafana/d-solo/ffc2356uvxl34a/maximos"
      panelIds={[1,2,3]}           
      panelParamName="panelId"
      iframeHeight={300}
    />
  );
}

if (leaf && leaf.to === "supervision/analisis/disponibilidad-mensual") {
  return (
    <ReportSup
      baseUrl="/service/grafana/d-solo/dfc216p7zgf7kf/disponibilidad"
      panelIds={[1]}     
      panelParamName="panelId"
      iframeHeight={300}
    />
  );
}

  if (leaf && leaf.to === "supervision/analisis/promedio-trafico") {
  return (
    <ReportePromedioMensual/>
  );
}

  const trail = leaf ? findPath(BUTTONS, (n) => n === leaf) || [] : [];
  const breadcrumbText = ["Reportes", ...trail.map((n) => n.label)].join(" / ");

  if (!leaf) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography sx={{ color: "text.secondary", textAlign: "center", py: 6 }}>
          Selecciona una opción del menú para ver el detalle.
        </Typography>
      </Box>
    );
  }

  const resetTs = location.state?.resetTs ?? 0;

  return (
    <Box sx={{ p: 2 }}>
      <GenericTextTable
        key={`${leaf.to || location.pathname}-${resetTs}`} 
        breadcrumb={breadcrumbText}
        title={(leaf.label || "").toUpperCase()}
        columns={leaf.columns || []}
        api={leaf.api}
        filtersConfig={leaf.filters || []}
        periodoMode={leaf.periodoMode || "api"}
        selectable={true}
      />
    </Box>
  );
}

export default function ReportesPrincipal() {
  const { includeRol: _includeRol } = useContext(GeneralContext);
  const items = BUTTONS;

  return (
    <PageBody>
      <Stack spacing={2} sx={{ pb: 2 }}>
        <Box>
          <Grid container spacing={1.5}>
            {items.map((item) => (
              <Grid
                key={item.path}
                size={item.size ?? 12}
                xs={item.xs}
                sm={item.sm}
                md={item.md}
                lg={item.lg}
                xl={item.xl}
              >
                <HoverMenuButton node={item} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
      <RouteDrivenSubView />
    </PageBody>
  );
}
